import React, { lazy, Suspense, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import RouteSuspense from "./common/RouteSuspense";
import Setup from "./screens/Setup/Setup";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { licenseChecked, setLicense } from "screens/systemSlice";
import { licenseAsync } from "./screens/systemThunks";
import { Box, Loader } from "mds";

const LoginPage = lazy(() => import("./screens/login/LoginPage"));
const LogoutPage = lazy(() => import("./screens/logout/LogoutPage"));
const LoginCallback = React.lazy(() => import("./screens/login/LoginCallback"));
const MissionControlApp = lazy(() => import("components/Kbar"));

function MainRouter() {
  const dispatch = useAppDispatch();

  const license = useAppSelector((state) => state.system.license);
  const licenseCheck = useAppSelector((state) => state.system.licenseStatus);

  useEffect(() => {
    const licenseTag = document.querySelector('meta[name="license"]');
    if (licenseTag) {
      if (licenseTag.getAttribute("content") !== "n/a") {
        dispatch(setLicense(licenseTag.getAttribute("content")));
      }
      dispatch(licenseChecked());
    }
    if (process.env.NODE_ENV === "development") {
      dispatch(licenseAsync());
    }
  }, [dispatch]);
  return (
    <Suspense fallback={<RouteSuspense />}>
      <Routes>
        <Route path={"/oauth_callback"} element={<LoginCallback />} />
        <Route path={"/login"} element={<LoginPage />} />
        <Route path={"/logout"} element={<LogoutPage />} />
        <Route
          path={"/setup"}
          element={
            licenseCheck === "failed" || licenseCheck === "idle" ? (
              license ? (
                <Navigate to="/" />
              ) : (
                <Setup />
              )
            ) : (
              <Box
                sx={{
                  height: "100vh",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Loader />
              </Box>
            )
          }
        />
        {(licenseCheck === "failed" || licenseCheck === "idle") && (
          <Route
            path={"*"}
            element={
              license ? (
                <ProtectedRoute>
                  <MissionControlApp />
                </ProtectedRoute>
              ) : (
                <Navigate to="/setup" />
              )
            }
          />
        )}

        {(licenseCheck === "failed" || licenseCheck === "idle") && (
          <Route path={"*"} element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Suspense>
  );
}

export default MainRouter;
